import React from 'react'

const Footer = () => {
  return (
    <div className='contain bg-black p-10 space-y-6'>
      <div className="flex justify-between">

        <div className='space-y-2'>
          <h6 className='text-[12px] text-[#C3C3C3] font-[500]'>Header</h6>
          <div className='space-y-1'>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
          </div>
        </div>
        <div className='space-y-2'>
          <h6 className='text-[12px] text-[#C3C3C3] font-[500]'>Header</h6>
          <div className='space-y-1'>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
          </div>
        </div>
        <div className='space-y-2'>
          <h6 className='text-[12px] text-[#C3C3C3] font-[500]'>Header</h6>
          <div className='space-y-1'>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
          </div>
        </div>
        <div className='space-y-2'>
          <h6 className='text-[12px] text-[#C3C3C3] font-[500]'>Header</h6>
          <div className='space-y-1'>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
            <p className='text-[12px] text-[#C3C3C3]'>Item 1</p>
          </div>
        </div>

      </div>
      <div className='border-t-2 border-[#F4F4F4] flex justify-between'>
        
        <p className='text-[#C3C3C3] text-[12px] lg:text-[16px]'>PERSONAL ASSISTANT Inc</p>
        <div>
          
        </div>
      </div>
    </div>
  )
}

export default Footer
